import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    userPhoto: null,
    divisions: Array,
    businessUnitIds: Array,
    isOnline: navigator.onLine,
    isAdmin: Boolean,
    readOnly: Boolean
    //isExports: Boolean,
  },
  getters: {
    user: state => state.user,
    userPhoto: state => state.userPhoto,
    userPrincipalName: state => (state.user === null ? null : state.user.userPrincipalName),
    divisions: state => state.divisions,
    businessUnitIds: state => state.businessUnitIds,
    isOnline: state => state.isOnline,
    isAdmin: state => state.isAdmin,
    readOnly: state => state.readOnly
    //isExports: state => state.isExports
  },
  mutations: {
    updateUser: (state, user) => {
      state.user = user.data;
    },
    updateUserPhoto: (state, userPhoto) => {
      state.userPhoto = userPhoto.data;
    },
    updateOnlineStatus: (state, isOnline) => {
      state.isOnline = isOnline.data;
    },
    updateDivisions: (state, divisions) => {
      state.divisions = divisions.data;
    },
    updateAdminStatus: (state, isAdmin) => {
      state.isAdmin = isAdmin.data;
    },
    updateReadOnlyStatus: (state, readOnly) => {
      state.readOnly = readOnly.data;
    },
    updateBusinessUnitIds: (state, businessUnitIds) => {
      state.businessUnitIds = businessUnitIds.data;
    }
    // updateExportStatus: (state, isExport) => {
    //   state.isExports = isExport.data;
    // }
  },
  actions: {
    setOnlineStatus(context, isOnline) {
      context.commit("updateOnlineStatus", { data: isOnline });
    },
    updateDivision(context, divisions) {
      context.commit("updateDivisions", { data: divisions });
    },
    updateUser(context, user) {
      context.commit("updateUser", { data: user });
    },
    updateUserPhoto(context, userPhoto) {
      context.commit("updateUserPhoto", { data: userPhoto });
    },
    setAdminStatus(context, isAdmin) {
      context.commit("updateAdminStatus", { data: isAdmin });
    },
    setReadOnlyStatus(context, readOnly) {
      context.commit("updateReadOnlyStatus", { data: readOnly });
    },
    updateBusinessUnitId(context, businessUnitIds) {
      context.commit("updateBusinessUnitIds", { data: businessUnitIds });
    }
    // setExportStatus(context, isExport) {
    //   context.commit("updateExportStatus", { data: isExport });
    // }
  },
  modules: {}
});
